import { apiCaller, checkStatusResponse } from "../helpers";
import { setStateAdmin } from "./admins";

//Default State
const initialState = {
  postOffices: {},
};

//Reducer
export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_CATEGORIES":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_CATEGORIES":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}

//Action
// set state dashboard
export function setStateCategories(propertyName, value) {
  return {
    type: "SET_STATE_CATEGORIES",
    propertyName,
    value,
  };
}

// set multi dashboard
export function setMultipleStateCategories(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_CATEGORIES",
    newObject,
  };
}

export function getPostOffice(pageIndex, pageSize, queryString) {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller(
        `/api/postoffice/getallpostoffice?queryString=${queryString}&provinceCode=null&communeCode=null&districtCode=null&pageIndex=${pageIndex}&pageSize=${pageSize}`
      );
      const { response } = res.data;
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateCategories("postOffices", response));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", false));
      checkStatusResponse(error.response);
    }
  };
}
